export const ANAMOLY_LIST_SUCCESS = 'ANAMOLY_LIST_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const ANAMOLY_DETAIL_SUCCESS = 'ANAMOLY_DETAIL_SUCCESS';
export const ANAMOLY_CONFIG_SINGLE = 'ANAMOLY_CONFIG_SINGLE';
